export default __webpack_public_path__ + "static/media/checklist2.7d322c96.svg";